import { useEffect } from 'react';

const useProfileMediaRealtime = ({ userData, publicBaseUrl }) => {
  useEffect(() => {
    if (!userData) return;
    const avatarPath = userData.avatar || '';
    const backgroundPath = userData.background || '';
    const googleAvatar = userData.googleAvatarUrl || '';
    const isExternalUrl = (value) => /^https?:\/\//i.test(value || '');

    const buildUrl = (path) => {
      if (!path) return '';
      if (isExternalUrl(path)) return path;
      if (!publicBaseUrl) return path;
      return `${publicBaseUrl}/${path}`;
    };

    const avatarUrl = avatarPath ? buildUrl(avatarPath) : (googleAvatar || '');
    const backgroundUrl = buildUrl(backgroundPath);

    const cacheKey = 'theralingua_preload_media';
    const cacheValue = `${userData.id}|${avatarUrl}|${backgroundUrl}`;
    if (sessionStorage.getItem(cacheKey) === cacheValue) return;
    sessionStorage.setItem(cacheKey, cacheValue);

    if (avatarUrl) {
      const avatarImg = new Image();
      avatarImg.src = avatarUrl;
    }
    if (backgroundUrl) {
      const backgroundImg = new Image();
      backgroundImg.src = backgroundUrl;
    }
  }, [userData, publicBaseUrl]);
};

export default useProfileMediaRealtime;
